import type { ReactNode } from "react";

import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { useGetCurrentUserInfo } from "~/shared/hooks/use-current-user-info.ts";
import { useDeploymentType } from "~/shared/hooks/use-deployment-type.ts";

type RoleGuardProps = {
	readonly allowedRoles: ReadonlySet<string>;
	readonly children: ReactNode;
};

export function RoleGuard({ allowedRoles, children }: RoleGuardProps) {
	const { isInternal } = useDeploymentType();
	const { data: currentUser, isLoading } = useGetCurrentUserInfo(isInternal);

	if (isLoading) {
		return <LoadingSpinner />;
	}

	const userRole = currentUser?.role ?? "";

	if (!allowedRoles.has(userRole)) {
		return (
			<Construction
				message={"You do not have the required permissions to view this page."}
				routingEnabled={true}
				title={"Access Denied"}
			/>
		);
	}

	return children;
}
